const MobileInterface = {
  openLink(url) {

    if (window.AndroidInterface) {
      //use android interface
      window.AndroidInterface.openLink(url)
    } else {
      //try ios interface
      try {
        window.webkit.messageHandlers.openLink.postMessage(url);
      } catch (error) {
        //fallback
        //erro
      }
    }
  },

  setOneSignalExternalUserId(id) {

    if (window.AndroidInterface) {
      //use android interface
      window.AndroidInterface.setOneSignalExternalUserId(id);
      console.log('OneSignal ID set to: ', id);
      
    } else {
      //try ios interface
      try {
        window.webkit.messageHandlers.setOneSignalExternalUserId.postMessage(id);
      } catch (error) {
        //fallback
        //erro
      }
    }
  },
}

export default MobileInterface;